import { render, staticRenderFns } from "./QueueStatus.vue?vue&type=template&id=2bf947c2&scoped=true"
import script from "./QueueStatus.vue?vue&type=script&lang=js"
export * from "./QueueStatus.vue?vue&type=script&lang=js"
import style0 from "./QueueStatus.vue?vue&type=style&index=0&id=2bf947c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf947c2",
  null
  
)

export default component.exports